'use client'

import { useCallback } from 'react'
import { homeButtonClasses } from '@/components/marketing/home/home-button'
import { EMAIL_AUDIT_RENDERING } from '@/lib/site/email-audit-content'
import { useAuditedEmail } from './audited-email-context'
import { EmailAuditHandoffBlocked } from './email-audit-handoff-blocked'
import { useEmailAuditHandoff } from './use-email-audit-handoff'

/**
 * Carries the email this page audited into Brew, or just opens sign-in. On a
 * shared report there is no audited email (no provider), so it only signs in.
 */
export function RenderingBandCta() {
  const audited = useAuditedEmail()
  const handoff = useEmailAuditHandoff(audited?.html ?? null)
  const { continueInBrew, isLeaving } = handoff
  const handleClick = useCallback(
    () => continueInBrew('rendering'),
    [continueInBrew]
  )
  return (
    <div className="flex flex-col items-center gap-3">
      <button
        type="button"
        onClick={handleClick}
        disabled={isLeaving}
        className={homeButtonClasses()}
      >
        {audited
          ? EMAIL_AUDIT_RENDERING.ctaWithEmail
          : EMAIL_AUDIT_RENDERING.ctaWithoutEmail}
        <span aria-hidden="true" className="ml-1">
          →
        </span>
      </button>
      {handoff.isBlocked ? (
        <EmailAuditHandoffBlocked handoff={handoff} isCentered />
      ) : null}
    </div>
  )
}
